"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const use_user_routes_permissions_1 = require("./use-user-routes-permissions");
const hooks_1 = require("../hooks");
const localization_1 = require("../localization");
const store_1 = require("../store");
const creators_1 = require("../store/actions/creators");
const RequestLoader = ({ children }) => {
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const token = (0, hooks_1.useToken)();
    const { getUserRole } = (0, use_user_routes_permissions_1.useUserRoutePermissions)();
    const requestOrganizations = () => __awaiter(void 0, void 0, void 0, function* () {
        let organizations = [];
        try {
            organizations = yield client.organizations.getMany();
        }
        catch (_a) {
            addError(t({ key: 'ORGANIZATIONS_FAIL_LOAD' }));
        }
        if (organizations.length === 1) {
            dispatch((0, creators_1.organizationsSetIds)([organizations[0].id]));
        }
        dispatch((0, store_1.organizationsSetData)(organizations));
    });
    // user role loading state is set to true in the redux store on initial load
    // this is because the request loader runs on load and therefore this function will always run,
    // setting the loading state to false in the finally block
    const requestUserRole = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const userRole = yield getUserRole();
            dispatch((0, creators_1.userSetRole)(userRole));
        }
        catch (_a) {
            dispatch((0, creators_1.userSetRole)(null));
            addError(t({ key: 'IDENTITY_FAIL_LOAD' }));
        }
        finally {
            dispatch((0, creators_1.userSetIsRoleLoading)(false));
        }
    });
    (0, react_1.useEffect)(() => {
        if (token) {
            void requestOrganizations();
        }
    }, [token]);
    (0, react_1.useEffect)(() => {
        if (token) {
            void requestUserRole();
        }
    }, [token]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = RequestLoader;
